// Core
import React, { useState } from "react";

// Redux
import { useDispatch } from "react-redux";
import {
  changeNewPasswordRequest,
  logoutRequest,
} from "../../../../../Redux/Slices/Common/commonSlice";

// Utils
import {
  validateCurrentAndNewPassword,
  validateInput,
  validatePasswords,
} from "Services/Utils/validateInput";

// Custom component
import Button from "Components/Button";
import ErrorMessage from "Components/ErrorMessage";
import InputBox from "Components/InputBox";
import { notifySuccess } from "Services/Utils/toastNotification";
import { useNavigate } from "react-router-dom";

const ChangePassword = ({ goToNextTab }) => {
  //Initialize redux
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const buttonTitleStyle = {
    fontSize: "16px",
    fontWeight: "600",
  };

  const buttonStyle = {
    height: "44px",
  };
  const settingBoxStyle = {
    border: "1px solid #858485",
    outline: "none",
    borderRadius: "12px",
  };
  const settingLabelStyle = {
    color: "#545454",
    fontSize: "16px",
    fontWeight: "400",
  };

  // Initial state for form data and errors
  const initialFormData = {
    currentPassword: "",
    password: "",
    confirmPassword: "",
  };
  const initialErrors = {};

  // Local states
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrors);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear error for the specific field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // Validate form data based on type
  const handleValidation = () => {
    let validationErrors = {};

    Object.keys(formData).forEach((key) => {
      const error = validateInput(key, formData[key]);
      if (Object.keys(error).length > 0) {
        validationErrors = { ...validationErrors, ...error };
      }
    });

    setErrors(validationErrors);
    return validationErrors;
  };

  // Validate and handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate passwords
    const validationErrors = handleValidation();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const validationErrors_ = validatePasswords(
        formData.password,
        formData.confirmPassword
      );

      if (Object.keys(validationErrors_).length > 0) {
        setErrors(validationErrors_);
      } else {
        const validationErrors__ = validateCurrentAndNewPassword(
          formData.currentPassword,
          formData.password
        );

        if (Object.keys(validationErrors__).length > 0) {
          setErrors(validationErrors__);
        } else {
          // Submit logic here
          dispatch(
            changeNewPasswordRequest({
              data: {
                new_password: formData?.password,
                confirm_password: formData?.confirmPassword,
                password: formData?.currentPassword,
              },
              callBack: changeNewPasswordRequestCB,
            })
          );
          const logoutRequestCB = () => {
            localStorage?.setItem("isLoggedIn", null);
            localStorage?.setItem("userDetails", null);
            navigate("/", { replace: true });
          };
          dispatch(
            logoutRequest({
              callBack: logoutRequestCB,
            })
          );
        }
      }
    }
  };

  const changeNewPasswordRequestCB = () => {
    notifySuccess("Password changed successfully!");
    goToNextTab();
  };

  return (
    <div className="p-4">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-6 my-5">
            <InputBox
              label="Current Password"
              name="currentPassword"
              type="password"
              required
              value={formData.currentPassword}
              onChange={handleChange}
              inputStyle={settingBoxStyle}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.currentPassword} />
          </div>
          <div className="col-6 my-5">
            <InputBox
              label="New Password"
              name="password"
              type="password"
              required
              value={formData.password}
              onChange={handleChange}
              inputStyle={settingBoxStyle}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.password} />
          </div>
          <div className="col-6">
            <InputBox
              label="Confirm New Password"
              name="confirmPassword"
              type="password"
              required
              value={formData.confirmPassword}
              onChange={handleChange}
              inputStyle={settingBoxStyle}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.confirmPassword} />
          </div>
        </div>
        <div className="col-2 mt-5">
          <Button
            title="Submit & Next"
            titleStyle={buttonTitleStyle}
            buttonStyle={buttonStyle}
            forForm
          />
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
